/* eslint-disable */
import { produce } from "immer";
import {
  ACCOUNT_FETCH_FAILURE,
  ACCOUNT_FETCH_SUCCESS,
  ACCOUNT_FETCH_START,
} from "../actions/types";

const account = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case ACCOUNT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case ACCOUNT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case ACCOUNT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default account;
